// #IncludeAdminsAsLevantadores — super_admin y lider_proyecto deben
// poder ser asignados como Levantador en evaluaciones, eventos y
// proyectos. Antes los filtros usaban estrictamente role === 'levantador'
// y los admins quedaban excluidos de los dropdowns "Asignar Levantador".
//
// Mantén este array y los helpers como única fuente de verdad. Si
// agregamos más roles que puedan "levantar", agrégalos aquí.

export const ROLES_AS_LEVANTADOR = ['super_admin', 'lider_proyecto', 'levantador'];

// #IncludeAdminsAsLeaders — los super_admin también pueden actuar como
// Líder de Proyecto en cualquier selector que pida un líder. Antes el
// filtro era estricto role === 'lider_proyecto' y los super admins
// quedaban fuera.
export const ROLES_AS_LIDER = ['super_admin', 'lider_proyecto'];

const isActiveUser = (u) => u && u.is_active !== false;

const byName = (a, b) => (a.name || '').localeCompare(b.name || '', 'es', { sensitivity: 'base' });

/** Filtra usuarios que pueden actuar como Líder de Proyecto y los
 *  devuelve ordenados alfabéticamente. */
export function listSelectableLideres(users) {
  if (!Array.isArray(users)) return [];
  return users
    .filter((u) => ROLES_AS_LIDER.includes(u.role) && isActiveUser(u))
    .sort(byName);
}

/** Filtra usuarios que pueden actuar como Levantador y los devuelve
 *  ordenados alfabéticamente por nombre (es, sin sensitivity). */
export function listSelectableLevantadores(users) {
  if (!Array.isArray(users)) return [];
  return users
    .filter((u) => ROLES_AS_LEVANTADOR.includes(u.role) && isActiveUser(u))
    .sort(byName);
}

/** Etiqueta visible para chips/badges del selector. Muestra rol entre
 *  paréntesis solo si NO es un levantador puro (ayuda al admin a saber
 *  que está asignando a un super_admin o líder a un rol auxiliar). */
export function formatLevantadorLabel(user) {
  if (!user) return '';
  const role = user.role;
  if (role === 'levantador') return user.name || user.email || '';
  const tag = role === 'super_admin' ? 'Super Admin' : role === 'lider_proyecto' ? 'Líder' : role || '';
  return `${user.name || user.email || ''}${tag ? ` (${tag})` : ''}`;
}
